<div class="d-flex">
  <app-components-navbar></app-components-navbar>
  <div class="capsule">
    <app-navtabs [type]="'security-policies'"></app-navtabs>
  </div>
</div>
  